import { CloseCircle } from "iconsax-react-nativejs";
import { Pressable, Text, View } from "react-native";
import { useRouter } from "expo-router";
import { capitalizeName } from "@/src/utils/string.utils";

type MentionedUserPillProps = Readonly<{
  displayName: string;
  userId: string;
  onRemove?: () => void;
  isEditing: boolean;
}>;

const MentionedUserPill = ({
  displayName,
  userId,
  onRemove,
  isEditing = false,
}: MentionedUserPillProps) => {
  const router = useRouter();

  const handleProfilePress = () => {
    router.push(`/profile/${userId}`);
  };

  return (
    <View className="flex-row items-center gap-1.5 rounded-full pr-2 border-primary">
      {/* Clickable name area */}
      <Pressable
        onPress={!isEditing ? handleProfilePress : undefined}
        className="flex-row items-center gap-1.5 flex-1 px-2 py-1 hover:bg-ash-3 hover:rounded-full"
      >
        <Text className="text-sm text-primary hover:underline decoration-1">
          @{capitalizeName(displayName)}
        </Text>
      </Pressable>

      {/* Remove button */}
      {onRemove && (
        <Pressable onPress={onRemove} hitSlop={8} className="p-1 hover:bg-ash-3 hover:rounded-full">
          {({ hovered }) => (
            <CloseCircle
              size={20}
              color={hovered ? "var(--color-primary-default)" : "var(--color-ash-1)"}
            />
          )}
        </Pressable>
      )}
    </View>
  );
};

export default MentionedUserPill;
